'use client';

import { useQuery } from '@tanstack/react-query';
import { QueryApi } from '@/features/query/api';
import { CountrySelect } from '@/shared/ui/country-select';
import { CurrencySelect } from '@/shared/ui/currency-select';
import { LanguageSelect } from '@/shared/ui/language-select';
import { LogoutButton } from '@/shared/ui/logout-button';
import { UserButton } from '@/shared/ui/user-button';

export const MenuFooter = () => {
    const customerQuery = useQuery(QueryApi.Customer.queries.Customer);

    return (
        <footer className="menu__footer">
            <div className="menu__footer-row">
                <UserButton />
                {customerQuery.data && <LogoutButton className="menu__logout" />}
            </div>
            <hr className="menu__divider" />
            <div className="menu__footer-selects">
                <LanguageSelect />
                <CountrySelect />
                <CurrencySelect />
            </div>
        </footer>
    );
};
